import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { StyledLabel } from 'elements/Label/Label';
import { FormInput, FormInputMultiline } from 'elements/Inputs/FormInput';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectPositionSwitch } from './PositionSwitchSection.data';
import { StyleHMINewDropdown } from '../HMISection/HMISection.styled';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const PositionSwitchSection = (props) => {
    const { formName, changeHandler, formData, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const formDropInput = (field) => field.isDropdown ? (
        <StyleHMINewDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                marginLeft={field.marginLeft}
                width={field.width}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly}
                inputTextAlign={field.inputTextAlign}
                paddingRightPlaceholder={field.paddingRightPlaceholder}
                marginTop={field.marginTop}
                marginBottom={field.marginBottom}
                direction={field.direction}
                marginRight={field.marginRight}
                borderBottom={field.borderBottom}
            />
        </StyleHMINewDropdown>
    )
        : formLabel(field);

    const formLabel = (field) => field.isLabel
        ? (
            <StyledLabel
                id={field.key}
                fontWeight={field.fontWeight}
                fontSize={field.fontSize}
                textAlign={field.textAlign}
                labelWidth={field.labelWidth}
                padding={field.padding}
                direction={field.direction}
            >
                {field.label}
            </StyledLabel>
        ) : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                color={field.color}
                isRequired={field.isRequired}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                textAlignLabel={field.textAlignLabel}
                textAlign={field.textAlign}
                handleChange={changeHandler}
                type={field.type}
                width={field.width}
                labelWidth={field.labelWidth}
                padding={field.padding}
                readOnly={field.readOnly || isFormReadOnly}
                maxLength={field.maxLength}
                direction={field.direction}
                marginBottom={field.marginBottom}
                marginRight={field.marginRight}
                marginLeft={field.marginLeft}
                borderTop={field.borderTop}
                borderBottom={field.borderBottom}
                borderLeft={field.borderLeft}
                borderRight={field.borderRight}
                height={field.height}
                marginTop={field.marginTop}
                userRole={userRole}
                hasDPSError={field.hasDPSError}
                hasHmiError={field.hasHmiError}
                hasInstError={field.hasInstError}
                hasDPSNotNullError={field.hasDPSNotNullError}
                isDisabled={field.isDisabled}
            />
        );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectPositionSwitch(formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ paddingBottom: '0', paddingTop: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isMultiline
                                    ? (
                                        <FormInputMultiline
                                            rows={3}
                                            id={field.key}
                                            name={field.key}
                                            label={field.label}
                                            value={field.value}
                                            type={field.type}
                                            isRequired={field.isRequired}
                                            isCalculated={field.isCalculated}
                                            isCalculatedNew={field.isCalculatedNew}
                                            handleChange={changeHandler}
                                            width={field.width}
                                            inputWidth={field.inputWidth}
                                            readOnly={isFormReadOnly}
                                            direction={field.direction}
                                            marginRight={field.marginRight}
                                            marginLeft={field.marginLeft}
                                            alignItems={field.alignItems}
                                        />
                                    )
                                    : formDropInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    dpsData: Forms.dpsData,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PositionSwitchSection);

PositionSwitchSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    userRole: PropTypes.string,
};
